import { Component, OnInit } from '@angular/core';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { LandingService } from 'app/main/pagina/landingProducto/landing-requerimientos/landing.service';
import { fuseAnimations } from '@fuse/animations';
@Component({
  selector: 'adminfocus',
  templateUrl: './admin-focus.component.html',
  styleUrls: ['./admin-focus.component.scss'],
  animations : fuseAnimations
})
export class AdminFocusComponent implements OnInit {
  idEmpresa : string;
  productosContratadosInter : backInter.infoProductos;
  aniosPulsecheck:any[]=[];
  noce:any[]=[];
  anioseleccionado:any;
  idiomaActual:string;
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERRORDATE',
    'SHEDULE.SAMEDATE'
  ];

  mensajesTraducirTS = {
    error1: '',
    error2: ''
  };
btnPortalConteos:boolean= false;
mostrarEncuestas: backInter.getEncuestasFocus;
  constructor(
    private odsService: ODSService,
    private activatedRoute:ActivatedRoute,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private landingService : LandingService,
  ) {
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    }

  ngOnInit() {
    console.log(localStorage.getItem('fechaProducto'));
    console.log(localStorage.getItem('tipoProductoRequerimientos'));
    console.log(localStorage.getItem('productoIDRequerimientos'));


    // this.getProductsByCompany();
    this.traduceTextosTS();
    this.getEncuestasAll();
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        //console.log(k);
        this.mensajesTraducirTS[k] = res;
        // console.log(this.mensajesTraducirTS[k]);
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;


  }




// private getProductsByCompany() {
//
//     this.wizardService.getProductos().subscribe((respuesta:backInter.infoProductos) => {
//       console.log("Dude");
//       console.log(respuesta);
//       this.productosContratadosInter = respuesta;
//       this.anioseleccionado= localStorage.getItem('fechaProducto');
//       console.log(this.anioseleccionado);
//
//       if(this.productosContratadosInter){
//
//         this.pulseCheckAños();
//
//       }
//     }, error => {
//       console.log("error", error);
//     })
//   }

  private navigateTo(ruta,encuestaID){
    localStorage.setItem('encuestaID', encuestaID);
    localStorage.setItem('encuestaIDFocusRequerimientos', encuestaID);
      this.router.navigate([ruta]);
  }

  getEncuestasAll(){
      let data:any = {productoId: localStorage.getItem('productoIDRequerimientos')}
      this.landingService.getMostrarEncuestas(data).subscribe((respuesta:backInter.getEncuestasFocus) => {
        console.log(respuesta);
        this.mostrarEncuestas = respuesta;
        // console.log(this.mostrarEncuestas);
      }, error => {
        console.log(error);
      });
    }
  //
  // pulseCheckAños(){
  //   let moment = require('moment');
  //   let fechaActualC = moment().format('YYYY/MM/DD');
  //     let fechaActual:number;
  //     let fechaPulse:any[]=[];
  //     this.productosContratadosInter.productosPulseCheck.sort( (a,b) => {
  //       if(a.fechaPulseCheck > b.fechaPulseCheck){
  //         return 1;
  //       } else{
  //         return -1;
  //       }
  //     });
  //     console.log(this.productosContratadosInter.productosPulseCheck);
  //
  //     this.productosContratadosInter.productosPulseCheck.forEach((element,i) => {
  //       let datosPulsechek:any={};
  //       console.log(element.completoPulseCheck);
  //
  //       let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
  //       let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));
  //
  //       if(fechaPortal){
  //         console.log("econtro 1");
  //       this.btnPortalConteos=true;
  //     }else{
  //       this.btnPortalConteos=false;
  //     }
  //       if(fechaActual){
  //        datosPulsechek={
  //          completoPulseCheck: element.completoPulseCheck,
  //          fechaLanzamiento: element.fechaLanzamiento,
  //          fechaPulseCheck: element.fechaPulseCheck,
  //          idPlantilla: element.idPlantilla,
  //          idPulseCheck: element.idPulseCheck,
  //          idSurvey: element.idSurvey,
  //          tokenConfig: element.tokenConfig,
  //          btnPortalConteos:this.btnPortalConteos
  //        }
  //
  //         console.log(datosPulsechek);
  //
  //         if(element.fechaPulseCheck == fechaActual){
  //           fechaPulse.push(element);
  //           // fechaPulse.push(datosPulsechek);
  //         }
  //         else {
  //           this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
  //           fechaPulse=[];
  //           fechaActual=element.fechaPulseCheck;
  //           fechaPulse.push(element);
  //           // fechaPulse.push(datosPulsechek);
  //         }
  //       }
  //       else{
  //         fechaActual=element.fechaPulseCheck;
  //         fechaPulse.push(element);
  //         // fechaPulse.push(datosPulsechek);
  //       }
  //       fechaPulse.sort( (a,b) => {
  //         if(a.numero > b.numero){ return 1; } else{ return -1; }
  //       });
  //       if(this.productosContratadosInter.productosPulseCheck.length ==(i+1)){
  //         this.aniosPulsecheck.push({fecha: element.fechaPulseCheck, datos: fechaPulse});
  //       }
  //     });
  //     console.log(this.aniosPulsecheck);
  //   }

}
